export default __webpack_public_path__ + "static/media/prestashop.b86a1090.svg";